var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/modules/_an-object.js
// module id = 74
// module chunks = 168707334958949